<!-- @format -->

<project-delivery-tag>
<style>
a.download{
	color: #00894B;
}
</style>
	<div class="container_contents">
	
		<div class="container_breadcrumb">
			<ul class="breadcrumb">
				<li class="breadcrumb-item"><a class="projects" onclick={(e)=>project(e)}>稼働プロジェクト</a></li>
				<li class="breadcrumb-item"><a onclick={(e)=>detail_page(e)}>詳細</a></li>
				<li class="breadcrumb-item"><h1>納品</h1></li>
			</ul>
		</div><!--/.container_breadcrumb-->

		<div class="contents">
			<section class="contents_area">
				<div class="contents_block detail">
					
					<p class="important_message">下記の案件について納品を行います。内容の詳細を再度ご確認の上、制作物を提出してください。</p>
										
					<div class="margin-spacing-2_top">
						<div class="container_project-info margin-spacing-1_bottom">
							<span class="status_label project_status_label-{state.detail.state} margin-spacing-1_right"></span>
						</div><!--/.container_project-info-->
						<ul class="information_list">
							<li class="information_list-item "><span class="information_list-item-title">プロジェクトID:</span>{state.detail.project_id}</li>
							<li class="information_list-item "><span class="information_list-item-title">発注元企業:</span>{state.detail.client_name}</li>
						</ul><!--/.information_list-->
						<h2 class="matter_heading-detail margin-spacing-2_bottom">{state.detail.title}</h2>
					</div>

					<div class="container_accordion" each={(delivery,idx) in state.delivery}>
						<div class="accordion_heading is-hide" onclick={e=>toggleAccordion(e)} style="justify-content:initial">
							<h3 class="heading-02 heading_normal">制作物{Number(delivery.num) + 1}<span class="status_label submission_status_label-{delivery.state} margin-spacing-2_left"></span></h3>
							<p class="note">（初回提出期限：{delivery.delivery_desired_date}）</p>
						</div><!--/.accordion_heading-->

						<div class="accordion_body" style="display:none">
							<template if={delivery.state == 100 || delivery.state == 101}>
								<h3 class="heading-04 margin-spacing-2_bottom">添付ファイル</h3>
								<ul class="file_list">
									<li class="file_list-item" if={delivery.file}>{delivery.file.name}<span class="file_list-item_close" onclick={e=>deleteFile(e,idx)}></span></li>
								</ul>
								<div class="box_flex03 margin-spacing-2_top">
									<div class="button button-secondary button-file" type="button" value="ファイルを選択する" data-target="" onclick={e=>selectFile(e,idx)}>ファイルを選択する</div>
								</div>

								<h3 class="heading-04 margin-spacing-1_bottom margin-spacing-4_top">申し送り事項など</h3>
								<p class="note">※納品条件に合っていない点がある場合やクライアント様への確認の為の提出などをする際に、必ず申し送り事項に詳細を記入してください。</p>
								<textarea class="textarea_input" name="message_{idx}" placeholder="ここに申し送り事項などを記入してください"></textarea>

								<div class="wrap_button margin-spacing-3_top">
									<div class="button button-primary" type="button" value="制作物を提出する" onclick={e=>submit(e,idx,delivery.project_submission_target_id)}><span class="icon_delivery"></span>制作物を提出する</div>
								</div>
							</template>
							<template if={delivery.histories.length > 0}>
								<h3 class="heading-04 margin-spacing-2_bottom margin-spacing-4_top">提出履歴</h3>
								<table class="contents_table margin-spacing-3_top margin-spacing-5_bottom">
									<tbody>
										<tr>
											<th class="">提出日時</th>
											<th class="">提出ファイル</th>
											<th class="">申し送り事項</th>
										</tr>
										<tr each={item in delivery.histories}>
											<td class="">{item.timestamp}</td>
											<td class=""><a class="download" target="_blank" onclick={e=>downloadFile(e, item.id)}>{item.filename}</a></td>
											<td class="">
												<div class="box_flex02">
													<button class="button button-tertiary-mini margin-spacing-1_right" type="button" value="詳細を確認" data-target="" onclick={e=>showMessage(e,item.message)}>詳細を確認</button>
													<button class="button button-tertiary-micro button-comment" onclick={e=>showMessage(e,item.inspection_message)} if={item.inspection_message}></button>
												</div>	
											</td>
										</tr>
									</tbody>
								</table><!--/.contents_table-->
							</template>
						</div><!--/.accordion_body-->
					</div><!--/.container_accordion-->

				</div><!--/.contents_block-->
			</section><!--/.contents_area-->
		</div><!--/.contents-->
		
		
	</div><!--/.container_contents-->

<input type="file" id="dummy_file" style="display:none" idx="" onchange={e=>addFile(e)} />
<message-modal-tag message={state.message} isOpen="{state.messageModalIsOpen}" onClose={closeMessage}></message-modal-tag>

<script>
  import di from "dependeny-injection";
  import messageModal from "@tags/modal/project/message-modal.riot";
  export default {
    components: {
      "message-modal-tag": messageModal,
    },
    project_id: false,
	state: {
		message: '',
	    messageModalIsOpen: false,
	    detail: {},
		delivery: {}
	},
	showMessage(e, message) {
		this.update({message:message, messageModalIsOpen: true});
	},
	closeMessage(){
		this.update({messageModalIsOpen: false});
	},
	downloadFile(e, submission_id) {
		this.api.request('delivery', 'fetch-file', {submission_id: submission_id})
			.then(data=> {
				const downLoadLink = document.createElement("a");
				downLoadLink.href = data;
				downLoadLink.click();
			});
	},
	submit(e,idx,project_submission_target_id){
		const message = this.$(`textarea[name=message_${idx}]`).value;
		const file = this.state.delivery[idx].file;
		if (!message) {
			alert("申し送り事項が記入されていません");
			return;
		}
		if (!file) {
			alert("ファイルが指定されていません");
			return;
		}
		if (!confirm('本当にこの内容で提出物を送信してもよろしいですか？')) {
			return;
		}
		const formData = new FormData();
		formData.append('project_id', this.project_id);
		formData.append('project_submission_target_id', project_submission_target_id);
		formData.append('message', message);
		formData.append(`file`, this.state.delivery[idx].file);
		this.api.request('delivery', 'submit', formData)
			.then(data=>{
				this.api.request('delivery', 'fetch-delivery', {id: this.project_id})
					.then(data=>this.update({delivery: data}));
			});

	},
    toggleAccordion(e) {
      const target = e.target.closest('div.accordion_heading');
      if (target.nextElementSibling.style.display === 'none') {
        target.classList.remove('is-hide');
        target.nextElementSibling.style.display = 'block';
      }else{
        target.classList.add('is-hide');
        target.nextElementSibling.style.display = 'none';
      }
      
    },
	deleteFile(e,idx) {
		this.state.delivery[idx].file = null;
		e.target.closest('li').remove();
		this.update();
	},
	addFile(e) {
		const idx = Number(e.target.idx);
		this.state.delivery[idx].file = e.target.files[0];
		this.update();
	},
	selectFile(e,idx) {
		this.$("#dummy_file").idx = idx;
		this.$("#dummy_file").click();
	},
    project(e) {
      di.router.push(`/project`);
    },
    detail_page(e) {
      di.router.push(`/project/detail/${this.project_id}`);
    },
    reload(data){
      this.update({detail: data});
    },
    closeButton(){
      	//親要素に対するクローズボタン
      $('.js-close').on('click',function(){
          $(this).parent().fadeOut();
        });
    },
    onBeforeMount(props, state) {
      if (!props.routeParams[0]) {
        return;
      }
      this.project_id = props.routeParams[0];
	  //this.project_id = 48;
      this.api = di.createApi('project');
      this.api.request('detail', 'fetch-detail', {id: this.project_id})
        .then(data=>this.update({detail: data}));

      this.api.request('delivery', 'fetch-delivery', {id: this.project_id})
        .then(data=>this.update({delivery: data}));
    },
    //onUpdated(props, state) {
	//	$(".accordion_body").css("display", "none");
	//	//this.continueButton()
	//	this.closeButton()
    //}
  }
</script>
</project-delivery-tag>
